import React from "react";
import { Select } from "./Select";
import { SelectId } from "./SelectId";

const salesReportTypes = [
    { id: 'month', label: 'By Month' },
    { id: 'quarter', label: 'By Quarter' },
    { id: 'half', label: 'By Half' },
    { id: 'year', label: 'By Year' }
];

export const SalesReportTypeSelect = (props) => {
    const options = [...salesReportTypes];
    if (props.rangePeriod) {
        options.push({ id: 'range', label: 'By Range' });
    }

    return props.valueIsId ? <SelectId options={options} defaultOption={salesReportTypes[0]['id']} {...props} labelField="label" /> : <Select options={options} defaultOption={salesReportTypes[0]['id']} {...props} labelField="label" />;
}

